import { struct } from 'io-ts/lib/Decoder';

import { Id as JobId } from '../../../../job/Id';

export const Params = struct({
	jobId: JobId,
});
